var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _polygon, _path25, _polygon2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle, _circle2, _path33, _path34, _path35, _path36, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 892,
    height: 500.74997,
    viewBox: "0 0 892 500.74997",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b2aec908-dac2-485e-9341-1f8763a52ddc-155",
    "data-name": "Path 133",
    d: "M985.57958,671.22213a96.07143,96.07143,0,0,1-4.48837,26.55724c-.06066.19954-.128.39608-.19349.59562H964.1494c.01758-.17892.03577-.3785.05338-.59562,1.11664-12.838-5.26293-90.04234-12.9611-103.40438C951.91613,595.4589,986.87818,630.43,985.57958,671.22213Z",
    transform: "translate(-154 -199.62501)",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bc80851e-3fc6-46a5-adb1-be50bb758626-156",
    "data-name": "Path 134",
    d: "M984.32281,697.77937c-.14011.19954-.28569.39911-.4349.59562h-12.565c.09523-.16985.20561-.36939.33358-.59562,2.07558-3.746,8.21919-14.94632,13.92187-26.55724,6.126-12.4777,11.751-25.42849,11.27734-30.11579C997.00248,642.16289,1001.24337,674.39069,984.32281,697.77937Z",
    transform: "translate(-154 -199.62501)",
    fill: "#f1f1f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ac74e0d2-c10f-4860-b119-67c8c5820ae0-157",
    "data-name": "Path 133",
    d: "M200.35039,678.20883a71.35136,71.35136,0,0,0,3.33348,19.7238c.045.14819.095.29416.1437.44236h12.43881c-.01306-.13288-.02657-.28111-.03964-.44236-.82932-9.53465,3.90872-66.87356,9.62608-76.79742C225.35191,621.94022,199.38594,647.91294,200.35039,678.20883Z",
    transform: "translate(-154 -199.62501)",
    fill: "#f1f1f1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "b887613c-750d-48e2-8424-1e5e637b4506-158",
    "data-name": "Path 134",
    d: "M201.28379,697.93263c.10405.14819.21218.29642.323.44236h9.33193c-.07073-.12615-.1527-.27434-.24775-.44236-1.54151-2.78211-6.10431-11.10049-10.33963-19.7238-4.54975-9.26707-8.7274-18.88549-8.37558-22.3667C191.86672,656.62682,188.71705,680.56208,201.28379,697.93263Z",
    transform: "translate(-154 -199.62501)",
    fill: "#f1f1f1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M808.04724,550.875c-93.94726-39.814-178.94189-38.30063-259-14-123.35253-21.54288-207.81933-18.20966-262,14v-100h521Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M808.04724,523.375c-86.55224-39.21744-172.99951-41.74936-260.75,0-89.87793-25.87812-176.76416-25.60749-260.75,0v-304c89.294-26.65094,176.15381-26.0105,260.75,0,89.36133-25.92066,176.356-26.74274,260.75,0Z",
    transform: "translate(-154 -199.62501)",
    fill: "#e5e5e5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M310.00244,257.10106,307.091,249.6494c1.14111-.4458,28.40759-10.98682,68.42358-16.36377,36.99609-4.97217,92.11572-6.15918,144.61279,16.41455l-3.16015,7.34961c-50.7417-21.81836-104.23145-20.66943-140.16956-15.86474C337.68091,246.416,310.27466,256.99462,310.00244,257.10106Z",
    transform: "translate(-154 -199.62501)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M310.00244,285.10106,307.091,277.6494c1.14111-.4458,28.40759-10.98682,68.42358-16.36377,36.99609-4.97168,92.11572-6.15869,144.61279,16.41455l-3.16015,7.34961c-50.7417-21.81836-104.23145-20.67041-140.16956-15.86474C337.68091,274.416,310.27466,284.99462,310.00244,285.10106Z",
    transform: "translate(-154 -199.62501)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M310.00244,313.10106,307.091,305.6494c1.14111-.4458,28.40759-10.98682,68.42358-16.36377,36.99609-4.97217,92.11572-6.15918,144.61279,16.41455l-3.16015,7.34961c-50.7417-21.81836-104.23145-20.67041-140.16956-15.86474C337.68091,302.416,310.27466,312.99462,310.00244,313.10106Z",
    transform: "translate(-154 -199.62501)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M310.00244,341.10106,307.091,333.6494c1.14111-.4458,28.40759-10.98682,68.42358-16.36377,36.99609-4.97119,92.11572-6.15967,144.61279,16.41455l-3.16015,7.34961c-50.7417-21.81836-104.23145-20.66992-140.16956-15.86474C337.68091,330.416,310.27466,340.99462,310.00244,341.10106Z",
    transform: "translate(-154 -199.62501)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M310.00244,369.10106,307.091,361.6494c1.14111-.4458,28.40759-10.98682,68.42358-16.36377,36.99609-4.97217,92.11572-6.15918,144.61279,16.41455l-3.16015,7.34961c-50.7417-21.81885-104.23145-20.66992-140.16956-15.86474C337.68091,358.416,310.27466,368.99462,310.00244,369.10106Z",
    transform: "translate(-154 -199.62501)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M310.00244,397.10106,307.091,389.6494c1.14111-.4458,28.40759-10.98682,68.42358-16.36377,36.99609-4.97119,92.11572-6.15918,144.61279,16.41455l-3.16015,7.34961c-50.7417-21.81885-104.23145-20.66943-140.16956-15.86474C337.68091,386.416,310.27466,396.99462,310.00244,397.10106Z",
    transform: "translate(-154 -199.62501)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M571.00244,456.10106,568.091,448.6494c1.14111-.4458,28.40759-10.98682,68.42358-16.36377,36.99609-4.97119,92.11572-6.15918,144.61279,16.41455l-3.16015,7.34961c-50.7417-21.81885-104.23145-20.66943-140.16956-15.86474C598.68091,445.416,571.27466,455.99462,571.00244,456.10106Z",
    transform: "translate(-154 -199.62501)",
    fill: "#f9a826"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M568.54724,402.36376V249.43407l2.80738-.87695c71.14331-22.22315,141.94165-22.21875,210.42773.01318l2.76489.89746V402.16014l-5.41235-2.043c-71.26953-26.89843-140.26025-26.91455-205.05542-.04736Zm105.56324-30.4502q50.22765,0,102.43676,18.7251V255.29491c-65.11425-20.53467-132.37695-20.52344-200,.03271V390.45311A266.35614,266.35614,0,0,1,674.11048,371.91356Z",
    transform: "translate(-154 -199.62501)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M776.71318,452.13854l1.04786-25.4511,35.9462-71.46937a10.36837,10.36837,0,0,1,4.70375-4.67666,10.48992,10.48992,0,0,1,8.1044-.52916,10.48617,10.48617,0,0,1,6.5397,6.62761,10.84685,10.84685,0,0,1,.45528,2.03538A10.38654,10.38654,0,0,1,832.468,364.654L796.473,436.22015Z",
    transform: "translate(-154 -199.62501)",
    fill: "#f9a826"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M822.8877,349.94029l-39.01961,77.58-2.975-1.4963,37.739-75.03389A9.94459,9.94459,0,0,1,822.8877,349.94029Z",
    transform: "translate(-154 -199.62501)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M833.0142,358.73859l-37.53234,74.623-2.975-1.49629,38.93871-77.41917a9.99773,9.99773,0,0,1,1.1347,2.35045A10.32774,10.32774,0,0,1,833.0142,358.73859Z",
    transform: "translate(-154 -199.62501)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M829.27773,352.07967l-39.451,78.43763-2.975-1.4963,39.50037-78.53588a9.68811,9.68811,0,0,1,1.2287.51722A10.19806,10.19806,0,0,1,829.27773,352.07967Z",
    transform: "translate(-154 -199.62501)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M781.226,447.86223l-3.96976,3.19722.33277-8.42931C778.952,443.103,780.42765,445.15484,781.226,447.86223Z",
    transform: "translate(-154 -199.62501)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M389.67444,539.72888,384.922,525.31334l5.063-47.401a6.17835,6.17835,0,0,1,1.64294-3.59484,6.25081,6.25081,0,0,1,4.40941-1.99459,6.24846,6.24846,0,0,1,5.0374,2.32533,6.46275,6.46275,0,0,1,.68075,1.0398,6.18914,6.18914,0,0,1,.67227,3.55332l-5.06981,47.46525Z",
    transform: "translate(-154 -199.62501)",
    fill: "#f9a826"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M393.99876,473.04346l-5.49583,51.45382-1.97311-.21075,5.31546-49.76514A5.92579,5.92579,0,0,1,393.99876,473.04346Z",
    transform: "translate(-154 -199.62501)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M401.49195,475.8274,396.2056,525.32l-1.97311-.21075,5.48443-51.34714a5.95733,5.95733,0,0,1,1.12577,1.07307A6.15337,6.15337,0,0,1,401.49195,475.8274Z",
    transform: "translate(-154 -199.62501)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M398.01153,472.89679,392.455,524.9194l-1.97312-.21075,5.56355-52.08778a5.77252,5.77252,0,0,1,.79378.03083A6.0769,6.0769,0,0,1,398.01153,472.89679Z",
    transform: "translate(-154 -199.62501)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M391.29481,536.39739l-1.54377,2.61574-1.582-4.77138C389.02849,534.21969,390.28182,535.05469,391.29481,536.39739Z",
    transform: "translate(-154 -199.62501)",
    fill: "#3f3d56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f2202155-5d0d-4949-a3af-453985752dd6",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bb56e1bb-a377-463a-b777-e3f2ac15f40f-159",
    "data-name": "Path 385",
    d: "M904.43982,522.824a8.30535,8.30535,0,1,1-14.42-8.24494q.02778-.04855.0562-.09678a8.9384,8.9384,0,0,1,.78233-1.10977l-6.98631-49.79568-.20922-1.49188-1.4191-10.1611-.20922-1.46457.77323.0364,13.536.61857,3.62961.16374.45484,9.2696,2.57439,52.11534a8.29444,8.29444,0,0,1,1.43729,10.16107Z",
    transform: "translate(-154 -199.62501)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a248d591-cba6-4901-9d10-c9b24d625163-160",
    "data-name": "Path 386",
    d: "M883.70282,462.53612l17.18834-1.57647a3.39309,3.39309,0,0,0,3.06015-3.67235l-3.18387-35.743a13.032,13.032,0,0,0-25.96079,2.3177q.033.36922.08688.73608l5.15422,35.05894a3.38765,3.38765,0,0,0,3.34579,2.89368A2.40171,2.40171,0,0,0,883.70282,462.53612Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f743e301-5bba-4392-b658-4efdfb4065cc-161",
    "data-name": "Path 387",
    d: "M896.73121,433.66028a23.939,23.939,0,0,0-8.80476-27.55227c-6.48144-4.43467-15.35078-6.02661-24.90239,5.34435a118.91248,118.91248,0,0,0-24.10642,47.758l39.11608,6.36773S891.33592,449.31761,896.73121,433.66028Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eac80286-6d9c-481f-b372-04b3b845d333-162",
    "data-name": "Path 388",
    d: "M833.466,689.83059H822.31333l-5.30524-43.0168h16.45968Z",
    transform: "translate(-154 -199.62501)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e474a022-de70-4f17-bf9b-ca694d09b1b4-163",
    "data-name": "Path 389",
    d: "M800.80766,700.18545H835.8584V686.6431H814.35a13.54235,13.54235,0,0,0-13.54235,13.54235Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9ae19c7-51aa-4dd0-9022-ef91b49440e0-164",
    "data-name": "Path 390",
    d: "M925.15587,680.10342l-10.58863,3.50046-18.5392-39.178,15.62824-5.16607Z",
    transform: "translate(-154 -199.62501)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bdf88be3-aecd-443e-97f8-a32ede953949-165",
    "data-name": "Path 391",
    d: "M897.39522,700.18535l33.28-10.99986-4.25-12.85819-20.42179,6.7499a13.54236,13.54236,0,0,0-8.60824,17.10815Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e601451a-496c-4b1c-9fe2-c3a71e9d5111",
    "data-name": "Ellipse 65",
    cx: 718.17632,
    cy: 172.86134,
    r: 22.34256,
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fd5880a1-dddd-4cd5-886d-5f97a9f21c4e-166",
    "data-name": "Path 392",
    d: "M852.61373,677.85651l10.35666-68.35765a3.18387,3.18387,0,0,1,6.2422-.27289l15.772,65.14374A4.12355,4.12355,0,0,0,889.613,677.449l43.50529-6.99175a4.09361,4.09361,0,0,0,3.26845-5.23064L879.65843,478.19712a3.184,3.184,0,0,1-.05549-1.63741l1.88849-8.18709a4.079,4.079,0,0,0-2.11682-4.56112c-7.725-3.94164-27.29029-12.136-42.05525-3.16022a4.14,4.14,0,0,0-1.89121,2.66263L791.11232,671.60248A4.09357,4.09357,0,0,0,794.751,676.532l53.44986,4.78674q.18191.01632.36386.01638a4.10082,4.10082,0,0,0,4.04624-3.47952Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "acdc6559-e36c-4b0b-aac1-c1a10856fa7d-167",
    "data-name": "Path 393",
    d: "M886.99131,356.70074a16.9016,16.9016,0,0,1-4.41647-3.83884,5.731,5.731,0,0,1-.88239-5.549c1.12891-2.4907,4.48288-3.27484,7.08274-2.42973s4.60751,2.88549,6.50691,4.85131c1.6729,1.72838,3.394,3.54046,4.18452,5.81373s.3857,5.156-1.5883,6.536c-1.93761,1.35361-4.723.79961-6.58606-.654a16.8,16.8,0,0,1-4.11628-5.70366Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8902353-3630-4aaa-9386-a524a4077d2f-168",
    "data-name": "Path 394",
    d: "M894.5589,350.33484c.12372-6.295,7.29925-10.80968,13.49688-9.69352s10.96068,6.39958,13.34495,12.227c5.03778,12.31247,1.25626,26.36151-3.59777,38.75222s-10.86154,24.9606-10.1529,38.24552a39.95755,39.95755,0,0,0,23.21039,33.658c-6.99359,3.17021-15.35352-.10461-21.23094-5.04689-13.052-10.97525-18.08982-30.516-11.97224-46.43353,3.01739-7.85142,8.33535-14.56845,12.48713-21.88317s7.19826-15.93572,5.05416-24.06911-11.26635-14.71767-19.065-11.57112Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b05157c8-b93b-43b3-a4ba-0cfdfe0a562e-169",
    "data-name": "Path 395",
    d: "M870.83638,382.40093c1.94762-3.29122,3.91161-7.61218.353-10.48948a7.33564,7.33564,0,0,0-5.50354-1.45549c-4.0135.484-8.38449.68317-12.26972-.775a11.502,11.502,0,0,1-6.67249-5.99568c-2.00128-4.75215.50578-10.52676,4.69848-13.53052a15.82834,15.82834,0,0,1,17.51854-.3102c5.43077-2.39881,12.01955-1.33176,16.95363,1.97035s8.30989,8.59006,10.1438,14.23643a27.47766,27.47766,0,0,1,.83964,15.11426A22.46169,22.46169,0,0,1,882.96508,396.52a8.08884,8.08884,0,0,1-7.98877-1.18256,15.02706,15.02706,0,0,1-4.0426-5.92564C870.19232,386.922,869.79661,384.15932,870.83638,382.40093Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fb245157-e4e6-4551-ad6a-dca5f4b0f94b-170",
    "data-name": "Path 397",
    d: "M804.55552,402.33738a9.57347,9.57347,0,0,1,.21741,1.49189l39.077,22.54361,9.49794-5.46805,10.12561,13.25579-15.87386,11.31455a7.27742,7.27742,0,0,1-8.7329-.21288l-40.29866-31.78953a9.55158,9.55158,0,1,1,5.982-11.13535Z",
    transform: "translate(-154 -199.62501)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b7c0657c-f78e-4619-b8ae-65b0c7791644-171",
    "data-name": "Path 398",
    d: "M845.15712,427.44082l12.63,16.36871a4.09355,4.09355,0,0,0,6.1858.33929L878.27025,429.302a11.371,11.371,0,1,0-13.57752-18.24405q-.18541.138-.36509.28341L846.3961,421.36783a4.09358,4.09358,0,0,0-1.24172,6.073Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "208.552 488.809 220.675 488.808 226.443 442.047 208.55 442.048 208.552 488.809",
    fill: "#a0616a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M359.45946,684.47563l23.87519-.001h.001a15.216,15.216,0,0,1,15.21515,15.2149v.49443l-39.09058.00145Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.156 483.561 126.143 485.373 138.836 439.999 123.121 437.325 114.156 483.561",
    fill: "#a0616a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M265.68954,678.80989l23.60707,3.56811.00095.00015a15.216,15.216,0,0,1,12.76973,17.31842l-.07392.48888-38.65154-5.84216Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M305.53509,456.69524l13.46077,3.52685-.89548,21.82368-.111,39.7342a7.96294,7.96294,0,1,1-10.53872,1.32422l-4.13638-39.87975Z",
    transform: "translate(-154 -199.62501)",
    fill: "#a0616a"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M303.192,431.69821a10.9883,10.9883,0,0,1,6.79265-9.7718,10.27307,10.27307,0,0,1,11.12014,1.78846,9.79485,9.79485,0,0,1,3.265,7.57486c.03549,12.78474-2.85071,31.41963-2.87992,31.606l-.04611.29647-19.67517,6.62559Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M338.37211,467.98947l30.09365-7.78983,13.91083,46.85.49443,174.53462-23.0127-.144-9.61983-141.26361L288.92887,670.70673l-24.72161-2.96659,53.89312-139.92436s-2.96659-24.72162,6.42762-37.08243l-1.97773-12.85524Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M318.08045,479.6456a4.61107,4.61107,0,0,1-.9838-3.70921l-13.72677-41.18081a10.47677,10.47677,0,0,1,2.88958-11.0581l5.959-5.41654,4.03827-16.15307,23.21007,5.67342-1.9123,7.64922,10.50427-1.90917,22.12488,49.27714-46.24681,18.4852-2.27757.03573A4.61041,4.61041,0,0,1,318.08045,479.6456Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M350.29546,444.87572l13.26156-4.21451,10.90865,18.92291,21.14543,33.64059a7.963,7.963,0,1,1-8.19893,6.75245L362.59929,468.4839Z",
    transform: "translate(-154 -199.62501)",
    fill: "#a0616a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M334.95343,425.00116a10.987,10.987,0,0,1,.51761-11.88858,10.2786,10.2786,0,0,1,10.35411-4.43251,9.79511,9.79511,0,0,1,6.80835,4.65655c6.86362,10.78577,14.38537,28.07835,14.46045,28.2512l.11926.27523-13.08676,16.11637Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.42916,
    cy: 181.05591,
    r: 18.44123,
    fill: "#a0616a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.83949,
    cy: 155.51358,
    r: 17.7636,
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M285.51745,369.848a17.76455,17.76455,0,0,0,27.43172-9.32737,17.76458,17.76458,0,1,1-34.652-7.28472A17.758,17.758,0,0,0,285.51745,369.848Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M355.62048,369.86773c-3.10107-5.5518-4.28766-7.87094-8.28612-11.24692-3.53584-2.98572-7.885-3.86253-11.393-1.0335A21.00834,21.00834,0,1,0,348.61719,376.871a21.18256,21.18256,0,0,0-.14313-2.37544C351.52334,374.06734,352.5712,370.296,355.62048,369.86773Z",
    transform: "translate(-154 -199.62501)",
    fill: "#2f2e41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M536,700.375H155a1,1,0,0,1,0-2H536a1,1,0,0,1,0,2Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1045,700.375H664a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-154 -199.62501)",
    fill: "#cbcbcb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 392.29724,
    y: 19.74997,
    width: 2,
    height: 303.03809,
    fill: "#cbcbcb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.13965724c7c9d571ab2c65f0924dc648.svg";
export { ForwardRef as ReactComponent };